import { View } from '@react-pdf/renderer'
import { Style } from '@react-pdf/types'

import { usePrinterStyles } from '../usePrinterStyles'

interface PrintHFlowProps {
  children: React.ReactNode
  styles?: Style
}

export const PrintHFlow = (props: PrintHFlowProps) => {
  const { children, styles } = props
  const { config } = usePrinterStyles()
  return <View style={[config.row, styles]}>{children}</View>
}
